/* Love Livo: mejoras de la versión móvil */
(function () {
  var T = window.LL_I18N || {};
  function t(key, fallback) { return T[key] || fallback; }

  function addViewAllLinks() {
    var urls = {};
    document.querySelectorAll('.love-livo-mega-menu .dow_title_link').forEach(function (link) {
      urls[link.textContent.trim()] = link.getAttribute('href');
    });

    document.querySelectorAll('#menu-drawer details details').forEach(function (details) {
      var summary = details.querySelector(':scope > summary');
      var list = details.querySelector(':scope > .menu-drawer__submenu > ul');
      if (!summary || !list || list.querySelector('.menu-drawer__menu-item--view-all')) return;

      var title = summary.textContent.trim();
      var url = urls[title];
      if (!url) return;

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = url;
      link.className = 'menu-drawer__menu-item menu-drawer__menu-item--view-all link link--text list-menu__item focus-inset';
      link.textContent = t('viewAll', 'Ver todo') + ' ' + title;
      item.appendChild(link);
      list.insertBefore(item, list.firstChild);
    });
  }

  function flattenFeaturedMenu() {
    var allUrls = ['/collections/todos-los-productos', '/collections/see-all-products'];

    function isAll(link) {
      var href = link && (link.getAttribute('href') || '').split('?')[0].replace(/\/$/, '').replace(/^\/[a-z]{2}(-[a-zA-Z]{2})?(?=\/)/, '');
      return !!href && allUrls.indexOf(href) !== -1;
    }

    function markLinks(links) {
      links.forEach(function (link) {
        link.classList.add(isAll(link) ? 'll-featured-all' : 'll-featured-link');
      });
    }

    document.querySelectorAll('.love-livo-mega-menu .middle-menu-list').forEach(function (list) {
      var title = list.querySelector(':scope > p > .dow_title_link');
      if (!isAll(title) || list.classList.contains('ll-featured')) return;
      list.classList.add('ll-featured');
      var links = list.querySelectorAll('.site-nav__childlist-item > a');
      markLinks(links);
      var reference = document.querySelector('.love-livo-mega-menu .middle-menu-list:not(.ll-featured) .dow_title_link');
      var style = reference && window.getComputedStyle(reference);
      links.forEach(function (link) {
        link.classList.add('main-bold-title');
        if (!style) return;
        ['font-size', 'letter-spacing', 'line-height', 'font-family', 'font-weight', 'text-transform'].forEach(function (property) {
          link.style.setProperty(property, style.getPropertyValue(property), 'important');
        });
      });
    });

    document.querySelectorAll('#menu-drawer .menu-drawer__submenu li > a').forEach(function (link) {
      var shortcuts = link.nextElementSibling;
      if (!isAll(link) || !shortcuts || shortcuts.tagName !== 'UL' || link.classList.contains('ll-featured-title')) return;
      link.classList.add('ll-featured-title');
      markLinks(shortcuts.querySelectorAll(':scope > li > a'));
    });
  }

  function addCheckoutButton() {
    var footer = document.querySelector('cart-drawer .drawer__footer');
    if (!footer || footer.querySelector('.ll-checkout')) return;

    var reviewLink = footer.querySelector('.ll-review-link') || footer.querySelector('a[href="/cart"]');
    if (!reviewLink) return;

    var button = document.createElement('button');
    button.type = 'submit';
    button.name = 'checkout';
    button.className = 'll-checkout';
    button.setAttribute('form', 'CartDrawer-Form');
    button.textContent = t('checkout', 'Finalizar compra');
    reviewLink.parentNode.insertBefore(button, reviewLink.nextSibling);
    reviewLink.classList.add('ll-review');
  }

  function fixShippingText() {
    var heading = document.querySelector('cart-drawer .freeShippingRemain');
    var amount = heading && heading.querySelector('#free_money');
    if (!amount) return;

    var value = amount.textContent.replace(/EUR/g, '').trim();
    var before = t('shippingBefore', '¡Te faltan '), after = t('shippingAfter', ' para el envío GRATIS!');
    var text = before + value + after;
    if (heading.dataset.llText === text) return;

    heading.dataset.llText = text;
    amount.textContent = value;
    heading.textContent = '';
    heading.append(before, amount, after);
  }

  var discountMessage = null;

  function showDiscountMessage(box, text, ok) {
    var msg = box.querySelector('.ll-discount__msg');
    msg.textContent = text;
    msg.classList.toggle('ll-discount__msg--error', !ok);
  }

  function applyDiscount(box) {
    var input = box.querySelector('input');
    var button = box.querySelector('button');
    var code = input.value.trim();
    if (!code) {
      showDiscountMessage(box, t('discountEmpty', 'Introduce un código de descuento.'), false);
      return;
    }

    button.disabled = true;
    showDiscountMessage(box, t('discountApplying', 'Aplicando…'), true);

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code, sections: ['cart-drawer', 'cart-icon-bubble'] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function (state) {
        var applied = (state.discount_codes || []).some(function (discount) {
          return discount.code.toLowerCase() === code.toLowerCase() && discount.applicable;
        });

        if (!applied) {
          button.disabled = false;
          showDiscountMessage(box, t('discountInvalid', 'Este código no es válido o no se puede aplicar a tu pedido.'), false);
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: '' })
          });
          return;
        }

        discountMessage = t('discountAppliedBefore', 'Código ') + code.toUpperCase() + t('discountAppliedAfter', ' aplicado.');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.renderContents && state.sections) {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        button.disabled = false;
        showDiscountMessage(box, t('discountError', 'No se ha podido aplicar el código. Inténtalo de nuevo.'), false);
      });
  }

  function addDiscountField() {
    var footer = document.querySelector('cart-drawer .drawer__footer');
    if (!footer || footer.querySelector('.ll-discount')) return;

    var details = document.createElement('details');
    details.className = 'll-discount';
    details.innerHTML =
      '<summary><span class="summary__title">' + t('discountTitle', '¿Tienes un código de descuento?') + '</span></summary>' +
      '<div class="ll-discount__box">' +
      '<div class="ll-discount__row">' +
      '<input type="text" name="ll-discount" autocomplete="off" autocapitalize="characters" placeholder="' + t('discountPlaceholder', 'Introduce tu código') + '" aria-label="' + t('discountLabel', 'Código de descuento') + '">' +
      '<button type="button">' + t('discountApply', 'Aplicar') + '</button>' +
      '</div>' +
      '<p class="ll-discount__msg" role="status"></p>' +
      '</div>';

    var caret = footer.querySelector('#Details-CartDrawer summary .icon-caret');
    if (caret) details.querySelector('.summary__title').appendChild(caret.cloneNode(true));

    var box = details.querySelector('.ll-discount__box');
    details.querySelector('button').addEventListener('click', function () {
      applyDiscount(box);
    });
    details.querySelector('input').addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyDiscount(box);
      }
    });

    var note = footer.querySelector(':scope > #Details-CartDrawer');
    footer.insertBefore(details, note ? note.nextSibling : footer.firstChild);

    if (discountMessage) {
      details.open = true;
      showDiscountMessage(box, discountMessage, true);
      discountMessage = null;
    }
  }

  function updateCartDrawer() {
    addCheckoutButton();
    addDiscountField();
    fixShippingText();
  }

  function initRelatedCarousel() {
    document.querySelectorAll('.related-products .product-grid, recently-viewed .product-grid').forEach(function (grid) {
      if (grid.llUpdate) {
        grid.llUpdate();
        return;
      }

      var arrow = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var nav = document.createElement('div');
      nav.className = 'll-carousel-nav';
      nav.innerHTML =
        '<button type="button" class="ll-carousel-btn ll-carousel-btn--prev" data-dir="-1" aria-label="' + t('prev', 'Anterior') + '">' + arrow + '</button>' +
        '<button type="button" class="ll-carousel-btn" data-dir="1" aria-label="' + t('next', 'Siguiente') + '">' + arrow + '</button>';
      grid.parentNode.insertBefore(nav, grid.nextSibling);

      function update() {
        var max = grid.scrollWidth - grid.clientWidth - 2;
        nav.hidden = max <= 0;
        nav.children[0].disabled = grid.scrollLeft <= 2;
        nav.children[1].disabled = grid.scrollLeft >= max;
      }

      nav.addEventListener('click', function (event) {
        var button = event.target.closest('button');
        if (!button) return;
        grid.scrollBy({ left: Number(button.dataset.dir) * grid.clientWidth, behavior: 'smooth' });
      });
      grid.llUpdate = update;
      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  // Oculta las flechas de las miniaturas cuando todas caben y no hay nada que desplazar
  function toggleThumbnailArrows() {
    document.querySelectorAll('.thumbnail-slider').forEach(function (slider) {
      var list = slider.querySelector('.thumbnail-list');
      if (!list) return;
      var fits = list.scrollWidth <= list.clientWidth + 2;
      slider.querySelectorAll(':scope > .slider-button').forEach(function (button) {
        button.style.display = fits ? 'none' : '';
      });
    });
  }

  function localizeConsent() {
    var english = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;

    document.querySelectorAll('.checkbox-v2-text').forEach(function (text) {
      if (text.dataset.llLocalized) return;
      var parts = text.innerHTML.split(/\s*<strong>\s*\/\s*<\/strong>\s*/);
      if (parts.length !== 2) return;
      text.innerHTML = english ? parts[1] : parts[0];
      text.dataset.llLocalized = 'true';
    });

    document.querySelectorAll('.checkbox-v2-popup-message').forEach(function (message) {
      var match = message.textContent.match(/^(.*?\.)\s+(You must .*)$/);
      if (match) message.textContent = english ? match[2] : match[1];
    });
  }

  function init() {
    addViewAllLinks();
    flattenFeaturedMenu();
    updateCartDrawer();
    initRelatedCarousel();
    toggleThumbnailArrows();
    window.addEventListener('resize', toggleThumbnailArrows);
    window.addEventListener('load', toggleThumbnailArrows);

    document.querySelectorAll('product-recommendations, recently-viewed').forEach(function (element) {
      new MutationObserver(initRelatedCarousel).observe(element, { childList: true, subtree: true });
    });

    localizeConsent();
    new MutationObserver(localizeConsent).observe(document.body, { childList: true, subtree: true });

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(updateCartDrawer).observe(drawer, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
